module.exports = __webpack_public_path__ + "img/exhibiciones-adicionales.bc2d5700.svg";